<!--
 * @Author: wangkg wangkegui@longfor.com
 * @Date: 2022-12-23 09:51:56
 * @LastEditors: wangkg wangkegui@longfor.com
 * @LastEditTime: 2022-12-23 09:54:36
 * @FilePath: /unified-development-platform/src/components/udp-label/index.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div class="udp-label">
    {{ label }}
  </div>
</template>
<script>
export default {
  name: 'UdpLabel',
  props: {
    label: {
      type: String,
      default: '',
    },
  },
  data() {
    return {};
  },
  methods: {},
};
</script>
<style lang="scss" scoped>
.udp-label {
  padding-left: 16px;
  width: 100%;
  height: 56px;
  line-height: 56px;
  background-color: #fff;
  font-size: 16px;
  color: var(--text-color-1);
  font-weight: 600;
  position: relative;
  &::before {
    content: '';
    position: absolute;
    top: 50%;
    left: 0;
    margin-top: -8px;
    width: 4px;
    height: 16px;
    background-color: var(--primary-color);
  }
}
</style>